import { getDefaultConfig } from './Store';

const isDevEnv = (env) => env === 'development';
const isProdEnv = (env) => env === 'production';
const isNonProdEnv = (env) => ['qa', 'development'].includes(env);
const isLocalEnv = (nodeEnv) => nodeEnv === 'development';

const wrappedIsDevEnv = (env) => {
  if (env) {
    return isDevEnv(env);
  }
  const { appEnv } = getDefaultConfig();
  return isDevEnv(appEnv);
};

const wrappedIsProdEnv = (env) => {
  if (env) {
    return isProdEnv(env);
  }
  const { appEnv } = getDefaultConfig();
  return isProdEnv(appEnv);
};

const wrappedIsNonProdEnv = (env) => {
  if (env) {
    return isNonProdEnv(env);
  }
  const { appEnv } = getDefaultConfig();
  return isNonProdEnv(appEnv);
};

const wrappedIsLocalEnv = (nodeEnv) => {
  if (nodeEnv) {
    return isLocalEnv(nodeEnv);
  }
  const { nodeEnv: configNodeEnv } = getDefaultConfig();
  return isLocalEnv(configNodeEnv);
};

export {
  wrappedIsDevEnv as isDevEnv,
  wrappedIsProdEnv as isProdEnv,
  wrappedIsNonProdEnv as isNonProdEnv,
  wrappedIsLocalEnv as isLocalEnv,
};
